import '../styles/DomainSearch.css';
import { useState } from 'react';

export default function DomainSearchSectionComponent() {
  const [domainName, setDomainName] = useState('');
  const [domainError, setDomainError] = useState('');

  const handleDomainSearch = () => {
    if (!domainName) {
      setDomainError('Please enter a domain to search');
      return;
    }

    setDomainError('');
    const searchUrl = `https://www.networksolutions.com/products/domain/domain-search-results?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100&enableAiSearch=true&domainName=${encodeURIComponent(domainName)}`;
    window.open(searchUrl, '_blank', 'noopener,noreferrer');
  };

  const badges = ['.site', '.website', '.space'];

  return (
    <div className="domain-search">
      <div className="domain-search__container">
        <div className="domain-search__form-row">
          <div className="domain-search__input-wrapper">
            <input
              id="domainName"
              type="text"
              className="domain-search__input"
              placeholder="Find the right domain name"
              aria-label="Domain search input"
              aria-required="true"
              value={domainName}
              onChange={(e) => setDomainName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleDomainSearch();
                }
              }}
            />
            <button
              type="button"
              id="domainBtn"
              className="domain-search__button"
              aria-label="Find your domain"
              onClick={handleDomainSearch}
            >
              Find your domain
            </button>
          </div>
          <div className="domain-search__error-message" id="domainError" role="alert" aria-live="polite">
            {domainError}
          </div>
        </div>
        <div
          id="domainAd"
          className="domain-search__ad"
          role="button"
          tabIndex={0}
          aria-label="Get your personal domain for $1.99"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              // Add functionality if this ad is clickable
            }
          }}
        >
          <a
            id="domainAd"
            className="domain-search__ad"
            href="https://www.networksolutions.com/domains/personal-domain?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get your personal domain for $1.99"
          >
            <div className="domain-search__ad-content">
              <div className="domain-search__badges">
                {badges.map((badge) => (
                  <div key={badge} className="domain-search__badge">
                    <span className="domain-search__badge-text">{badge}</span>
                  </div>
                ))}
              </div>

              <div className="domain-search__ad-text-container">
                <div className="domain-search__ad-text-wrapper">
                  <p className="domain-search__ad-text">Get your personal domain</p>
                  <p className="domain-search__ad-text">$1.99*/ first year</p>
                </div>
                <div className="domain-search__arrow" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M12.175 8.588H1C0.716667 8.588 0.479167 8.49217 0.2875 8.3005C0.0958333 8.10883 0 7.87133 0 7.588C0 7.30467 0.0958333 7.06717 0.2875 6.8755C0.479167 6.68383 0.716667 6.588 1 6.588H12.175L7.275 1.688C7.075 1.488 6.97917 1.25467 6.9875 0.988C6.99583 0.721333 7.1 0.488 7.3 0.288C7.5 0.104667 7.73333 0.00883333 8 0.0005C8.26667 -0.00783333 8.5 0.088 8.7 0.288L15.3 6.888C15.4 6.988 15.4708 7.09633 15.5125 7.213C15.5542 7.32967 15.575 7.45467 15.575 7.588C15.575 7.72133 15.5542 7.84633 15.5125 7.963C15.4708 8.07967 15.4 8.188 15.3 8.288L8.7 14.888C8.51667 15.0713 8.2875 15.163 8.0125 15.163C7.7375 15.163 7.5 15.0713 7.3 14.888C7.1 14.688 7 14.4505 7 14.1755C7 13.9005 7.1 13.663 7.3 13.463L12.175 8.588Z"
                      fill="white" />
                  </svg>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
